import script from "./CommunicationsList.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommunicationsList.ts.vue?vue&type=script&setup=true&lang=ts"

import "./CommunicationsList.ts.vue?vue&type=style&index=0&id=877eba82&lang=scss"

const __exports__ = script;

export default __exports__